import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    firstName: {
      name: 'ผู้แก้ไข',
      width: '1fr',
    },
    action: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    createdAt: {
      name: 'วันที่สร้าง',
      width: '1fr',
    },
    updatedAt: {
      name: 'วันที่แก้ไข',
      width: '1fr',
    },
  },
  columns: ['_increment', 'firstName', 'action', 'updatedAt'],
  // sortable: [],
};
